import { env } from "./EnvironmentConfig";

export const APP_NAME = "AvtoCard";
export const API_BASE_URL = env.API_ENDPOINT_URL;

// export const THEME_CONFIG = {
// 	navCollapsed: false,
// 	sideNavTheme: SIDE_NAV_LIGHT,
// 	locale: 'en',
// 	navType: NAV_TYPE_SIDE,
// 	topNavColor: '#3e82f7',
// 	headerNavColor: '#ffffff',
// 	mobileNav: false
// };

export const THEME_CONFIG = {
  navType: "SIDE",
  sideNavTheme: "SIDE_NAV_LIGHT",
  navCollapsed: false,
  topNavColor: "#f79621",
  headerNavColor: "#f79621",
  locale: "en",
};
